import { Button, Col, Row, Menu, Dropdown, Divider, Card } from "antd";
import { useParams } from "react-router-dom";
import React, { useState } from "react";
import "./index.css";

const menu = (
  <Menu
    style={{ width: "200px", height: "300px", overflow: "scroll" }}
    aria-label="Options"
  >
    <Menu.Item key="1">
      <p>
        <i className="fa-solid fa-table-list"> </i> View Workflow runs
      </p>
    </Menu.Item>
    <Menu.Item key="2">
      <p>
        <i className="fa-solid fa-play"> </i> Workflow runs link
      </p>
    </Menu.Item>

    <Menu.Item key="3">
      <p>
        <i className="fa-solid fa-forward"> </i> Run multiple
      </p>
    </Menu.Item>
    <Menu.Item key="4">
      <p>
        <i className="fa-regular fa-clock"> </i> Schedule Workflow
      </p>
    </Menu.Item>
    <Menu.Item key="5">
      <p>
        <i className="fa-solid fa-clock-rotate-left"> </i> Activity
      </p>
    </Menu.Item>
    <Menu.Item key="6">
      <p>
        <i className="fa-solid fa-eye"> </i> Subscribe
      </p>
    </Menu.Item>
    <Menu.Item key="7">
      <p>
        <i className="fa-solid fa-tag"> </i> Manage Tags
      </p>
    </Menu.Item>
    <Menu.Item key="8">
      <p>
        <i className="fa-solid fa-arrow-right"> </i> Move
      </p>
    </Menu.Item>
    <Menu.Item key="9">
      <p>
        <i className="fa-solid fa-copy"> </i> Duplicate
      </p>
    </Menu.Item>
    <Menu.Item key="10">
      <p>
        <i className="fa-solid fa-download"></i> Export
      </p>
    </Menu.Item>
    <Menu.Item key="11">
      <p>
        <i className="fa-solid fa-print"></i> Print
      </p>
    </Menu.Item>
    <Menu.Item key="12">
      <p>
        <i className="fa-solid fa-box-archive"> </i> Archive
      </p>
    </Menu.Item>

    <Menu.Item key="13">
      <p>
        <i className="fa-regular fa-trash-can"> </i> Delete
      </p>
    </Menu.Item>
  </Menu>
);

const cards = [
  { title: "", numberIcon: "fa-solid fa" },
  { title: "", numberIcon: "fa-solid fa" },
];
const PrivateLibraryItemPage = () => {
  const [clickedIndex, setClickedIndex] = useState(-1);
  const { category } = useParams();
  return (
    <div>
      <Row>
        <Col span={24}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <p>
                Viewing
                <i
                  key="viewA"
                  className="fa-brands fa-nfc-symbol "
                  style={{ marginLeft: "5px" }}
                ></i>{" "}
                {category}
              </p>
              <p>Private Library</p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                width: "40%",
              }}
            >
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button icon={<i className="fa-solid fa-ellipsis"></i>} />
              </Dropdown>

              <Button>
                <p>
                  <i className="fa-solid fa-circle-exclamation"></i> Edit Draft
                </p>
              </Button>
              <Button>
                <p>
                  <i className="fa-solid fa-play"></i> Run Workflow
                </p>
              </Button>
            </div>
          </div>
          <Divider />
        </Col>
      </Row>
      <Row style={{ marginBottom: "5px" }}>
        <Col span={24}>{category}</Col>
      </Row>
      <Row>
        <Col span={12}>
          {cards.map((card, index) => (
            <Row>
              <Col span={1}>
                <p style={{ lineHeight: "40px" }}>
                  <i className={`${card.numberIcon}-${index + 1}`}></i>
                </p>
              </Col>
              <Col span={22}>
                <Card
                  key={index}
                  className={clickedIndex === index ? "clicked" : ""}
                  onClick={() =>
                    setClickedIndex(index === clickedIndex ? -1 : index)
                  }
                ></Card>
              </Col>
            </Row>
          ))}
        </Col>
        <Col span={12} style={{ backgroundColor: "white", padding: "10px" }}>
          <Divider />
          <h3 style={{ color: "#8e9eac", textAlign: "center" }}>
            There is nothing here.
          </h3>
        </Col>
      </Row>
    </div>
  );
};
export default PrivateLibraryItemPage;
